import { useObservableValue, type Transfer } from '@talos/kyoko';
import { useMemo } from 'react';
import { map } from 'rxjs';

import { useTransfers } from '@src/providers';

function findTrackedTransfer(
  transfers: Transfer[],
  clientID: string | undefined,
  transferID: string | undefined
): Transfer | undefined {
  return transfers.find(
    transfer =>
      (clientID != null && clientID !== '' && transfer.ClientID === clientID) ||
      (transferID != null && transferID !== '' && transfer.TransferID === transferID)
  );
}

export function useTrackedTransfer(clientID: string | undefined, transferID: string | undefined) {
  const { transfersObs } = useTransfers();

  const trackedTransferObs = useMemo(
    () => transfersObs.pipe(map(transfers => findTrackedTransfer(transfers, clientID, transferID))),
    [transfersObs, clientID, transferID]
  );

  return useObservableValue(() => trackedTransferObs, [trackedTransferObs]);
}
